export const siglas = {
  methods: {
    nameSiglas(nombre) {
      const nombreWords = nombre.split(/\s+/)
      if (nombreWords.length >= 2) {
        return `${nombreWords[0].slice(0,1)}${nombreWords[1].slice(0,1)}`.toUpperCase()
      } else {
        return `${nombreWords[0].slice(0,2)}`.toUpperCase()
      }
    }
  }
}